import { createFileRoute, useParams } from "@tanstack/react-router";
import { TransferDetailPage } from "@/components/inventory/TransferDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/transfers_/$id")({
  component: AdminTransferDetail,
});

function AdminTransferDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/transfers_/$id" });
  return <TransferDetailPage transferId={id} />;
}
